import { render } from "./Targets.vue?vue&type=template&id=b3f89f12"
import script from "./Targets.vue?vue&type=script&lang=js"
export * from "./Targets.vue?vue&type=script&lang=js"

import "./Targets.vue?vue&type=style&index=0&id=b3f89f12&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__